import { SETTINGS_KEY } from 'src/pc/components/settings-modal'
import { JsqProductHS, UserInfoHS } from 'src/commons/store/UserStore'
import useRunDefaultSpeed from 'src/pc/components/hooks/useRunDefaultSpeed'
import { getPhpToken } from 'src/pc/utils/auth'
import { message } from 'antd'
import { sendMessageToSpeedBall } from 'src/commons/utils'

/**
 * 加速球
 */
class SpeedBall {
  //加速球位置 0端外  1端内
  position = 1
  //加速球是否可见  1可见 0隐藏
  visible = 1

  constructor() {
    this.listenMessage()
    const cfgStr = localStorage.getItem(SETTINGS_KEY)
    if (!cfgStr) {
      //没有设置时，默认显示加速球
      // console.log('settings', '首次默认显示加速球')
      this.setStatus()
      return
    }
    try {
      //有设置时，根据设置显示、隐藏加速球
      const cfg = JSON.parse(cfgStr)
      this.visible = ~~cfg.showSpeed
      this.setStatus()
    } catch (e) {}
  }

  listenMessage() {
    window.FuluApp?.RegisterCppNotifyCppFunc('cpp2js_speed2client_msg', (msg: string) => {
      console.log(`=> CppNotify:`, 'cpp2js_speed2client_msg', msg)
      let json: { __type__: string; [p: string]: any } = { __type__: '' }
      try {
        json = JSON.parse(msg)
      } catch (e) {
        console.log('e', e)
        return
      }
      const { __type__: type } = json
      switch (type) {
        case 'getSpeedTime':
          //领取加速器赠送时长
          this.onGetSpeedTime(json)
          break
        case 'runSpeedClient':
          //拉起加速器
          this.onRunSpeedClient()
          break
        case 'sensorsReport':
          //神策埋点
          this.onSensorsReport(json)
          break
        case 'getToken':
          sendMessageToSpeedBall('loginSuccess', { token: getPhpToken() })
          break
        case 'showMessage':
          //显示消息
          window.FuluApp?.JSNotifyCppFunc('set_window_foreground')
          message[json.type as keyof typeof message](json.message)
          break
        default:
          console.log('未处理的消息', json)
      }
    })
  }

  onSensorsReport(data: any) {
    window.gogReport?.(data.eventName)
  }

  private async onRunSpeedClient() {
    if (!JsqProductHS.SuccessResult) {
      await JsqProductHS.Execute()
    }
    const { defaultSpeed, runSpeedClient } = useRunDefaultSpeed(true)
    runSpeedClient(defaultSpeed)
  }

  private async onGetSpeedTime(data: any) {
    if (!JsqProductHS.SuccessResult) {
      await JsqProductHS.Execute()
    }
    const { defaultSpeed, runSpeedClient } = useRunDefaultSpeed(true)
    const userInfo = UserInfoHS.SuccessResult
    runSpeedClient({
      ...defaultSpeed!,
      extend: JSON.stringify({
        userInfo: null,
        source: 'speedBallGetSpeedTime',
        mobile: userInfo?.bindMobile ? '' : userInfo?.mobile ?? '',
        tokenGj: getPhpToken(),
        activityNo: data.activityNo,
        time: data.time,
      }),
    })
  }

  setStatus() {
    // console.log('settings 加速球', this.visible ? '显示' : '隐藏', this.position ? '端内' : '端外')
    window.FuluApp?.JSNotifyCppFunc('show_speed_ball', this.visible, this.position)
  }

  show() {
    // if (this.visible === 1) {
    //   return
    // }
    this.visible = 1
    this.setStatus()
  }

  hide() {
    // if (this.visible === 0) {
    //   return
    // }
    this.visible = 0
    this.setStatus()
  }

  setPosition(pos: number) {
    if (this.position === pos) {
      return
    }
    this.position = pos
    this.setStatus()
  }
}

export default SpeedBall
